export enum ContentSchemaSection {
  ContentMetadata = 'contentMetadata',
  ContentTypeMetadata = 'contentTypeMetadata',
  TemplateMetadata = 'templateMetadata',
  ContentSections = 'contentSections',
}

export enum ContentSectionKey {
  Abstract = 'abstract',
  Href = 'href',
  ContentData = 'contentData',
  Title = 'title',
}
